import { render, staticRenderFns } from "./add-Test.vue?vue&type=template&id=b568bb98&scoped=true&"
import script from "./add-Test.vue?vue&type=script&lang=js&"
export * from "./add-Test.vue?vue&type=script&lang=js&"
import style0 from "./add-Test.vue?vue&type=style&index=0&id=b568bb98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b568bb98",
  null
  
)

export default component.exports